import Player from "../player";

export const DEFAULT_TEAM_UNIFORM = "TM";

export default class TeamPlayer extends Player {
    constructor(teamId) {
        super(teamId, DEFAULT_TEAM_UNIFORM, [], "Team");
        this.playerId = `${DEFAULT_TEAM_UNIFORM}-${teamId}`;
    }

    static getUniform() {
        return DEFAULT_TEAM_UNIFORM;
    }
}
